import React, { PureComponent } from 'react';
import { Grid, Typography, Paper, Box, IconButton } from '@material-ui/core';
import AboutCompany from '../sections/aboutCompany';
import CompanyPerks from '../sections/companyPerks';
import { connect } from 'react-redux';
import { Chip } from 'common';
import { CreateOutlined } from '@material-ui/icons';
import { uuid } from 'utils';
import './view.scss';

class View extends PureComponent {
  render() {
    const {
      jobId,
      companyDetails,
      company,
      educationRequired,
      minExperience,
      maxExperience,
      positionCount,
      jobLocation,
      minSalary,
      maxSalary,
      currencyValue,
      salaryTime,
      skills,
      jobRole,
      employmentType,
      jobDescription,
      changeLocation,
      location,
      foundedYear,
      companySize,
      aboutCompany,
      perks,
    } = this.props;

    const salaryTimeStr = salaryTime === 'perHour' ? 'Per Hour' : 'Per Annum';

    return (
      <Grid item xs={7} className="view-job">
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Paper square elevation={0} className="the-job" id="the-job">
              <Box pb="18px" display="flex" alignItems="center">
                <Typography variant="body1" className="font-weight-500">
                  The Job
                </Typography>
                <Box flexGrow={1} textAlign="right">
                  <IconButton
                    edge="end"
                    aria-label="Edit"
                    onClick={changeLocation(`/job/${jobId}/edit`)}
                  >
                    <CreateOutlined />
                  </IconButton>
                </Box>
              </Box>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Typography className="field-heading">Job title</Typography>
                  <Typography className="field-value" variant="body2">
                    {jobRole}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className="field-heading">Company</Typography>
                  <Typography className="field-value" variant="body2">
                    {company || companyDetails.organizationName}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className="field-heading">
                    Position type
                  </Typography>
                  <Typography className="field-value" variant="body2">
                    {employmentType}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className="field-heading">
                    No of Positions
                  </Typography>
                  <Typography className="field-value" variant="body2">
                    {positionCount}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography className="field-heading">
                    Job Locations
                  </Typography>
                  <Box>
                    {jobLocation.map((location) => (
                      <Chip key={uuid()} label={location} />
                    ))}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Typography className="field-heading">Description</Typography>
                  <Box>
                    <div
                      className="field-value font-roboto"
                      dangerouslySetInnerHTML={{ __html: jobDescription }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper
              square
              elevation={0}
              className="qualification"
              id="qualification"
            >
              <Box pb="18px">
                <Typography variant="body1" className="font-weight-500">
                  Qualification
                </Typography>
              </Box>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography className="field-heading">Education</Typography>
                  <Typography className="field-value" variant="body2">
                    {educationRequired.join(', ')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography className="field-heading">
                    Work experience
                  </Typography>
                  <Typography className="field-value" variant="body2">
                    {minExperience} - {maxExperience} Years
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography className="field-heading">Skills</Typography>
                  <Box>
                    {skills.map((skill) => (
                      <Chip key={uuid()} label={skill} />
                    ))}
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper square elevation={0} className="qualification" id="budget">
              <Box pb="18px">
                <Typography variant="body1" className="font-weight-500">
                  Budget
                </Typography>
              </Box>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography className="field-value" variant="body2">
                    {minSalary} - {maxSalary} {currencyValue} {salaryTimeStr}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <AboutCompany
          location={location || companyDetails.location}
          foundedYear={foundedYear || companyDetails.foundedYear}
          companySize={companySize || companyDetails.companySize}
          aboutCompany={aboutCompany || companyDetails.aboutCompany}
        />
        <CompanyPerks perks={perks || companyDetails.perks} />
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  const { selectedJob } = state.job;
  return {
    ...selectedJob,
  };
};

export default connect(mapStateToProps, null)(View);
